import React from 'react'
import { MonthCaptionProps } from 'react-day-picker'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { getReadableMonthName } from '../constants'

interface MonthCaptionExtendedProps extends MonthCaptionProps {
  yearColor?: string
}

export function MonthCaption({
  calendarMonth,
  yearColor,
  ...props
}: MonthCaptionExtendedProps) {
  const { t } = useTypedTranslation()

  return (
    <div {...props}>
      <p style={{ fontWeight: 600 }}>
        {t(getReadableMonthName(calendarMonth.date))}{' '}
        <span style={{ color: yearColor }}>
          {calendarMonth.date.getFullYear()}
        </span>
      </p>
    </div>
  )
}
